import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";
import { journeyType } from "../../../../../context/checkout-journey-context";

const HomeAddressForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  readOnlyValues,
  stateTypesOptions,
  onChangeHandler,
  onResetHandler,
  residenceTypes,
  currentJourneyType,
  onBlurHandler,
  onFocusHandler,
}) => {  
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  const handleFocus = (event) => {
    onFocusHandler(event, formName);
  };

  const onDropdownChange = (event, val = null, formName) => {
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return (
    <CustomContainer className={`${formStyles["main-container"]} `}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={`${formStyles["form-group"]}`}
            controlId={`validationFormha101`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha101-label`}
            >
              Unit no.
              <span>(Optional)</span>
            </Form.Label>
            <Form.Control
              type="text"
              name={"unitNo"}
              value={fieldValues["unitNo"]}
              placeholder="#"
              readOnly={readOnlyValues["unitNo"]}
              onChange={handleChange}
              isInvalid={fieldErrors["unitNo"]}
              className={fieldErrors["unitNo"] ? formStyles["invalid"] : ""}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["unitNo"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={`${formStyles["form-group"]}`}
            controlId={`validationFormha102`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha102-label`}
            >
              Complex name
              <span>(Optional)</span>
            </Form.Label>
            <Form.Control
              type="text"
              name={"complexName"}
              value={fieldValues["complexName"]}
              placeholder="Add complex name"
              readOnly={readOnlyValues["complexName"]}
              onChange={handleChange}
              isInvalid={fieldErrors["complexName"]}
              className={
                fieldErrors["complexName"] ? formStyles["invalid"] : ""
              }
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["complexName"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={formStyles["form-group"]}
            controlId={`validationFormha103`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha103-label`}
            >
              Street no.
              <span>(Optional)</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="streetNo"
              value={fieldValues["streetNo"]}
              placeholder="#"
              maxLength="40"
              readOnly={readOnlyValues["streetNo"]}
              onChange={handleChange}
              isInvalid={fieldErrors["streetNo"]}
              className={fieldErrors["streetNo"] ? formStyles["invalid"] : ""}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["streetNo"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={`${formStyles["form-group"]}`}
            controlId={`validationFormha104`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha104-label`}
            >
              Street name
            </Form.Label>
            <Form.Control
              type="text"
              name="streetName"
              value={fieldValues["streetName"]}
              placeholder="Add street name"
              readOnly={readOnlyValues["streetName"]}
              onChange={handleChange}
              isInvalid={fieldErrors["streetName"]}
              className={fieldErrors["streetName"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["streetName"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="8"
            md="8"
            className={`${formStyles["form-group"]}`}
            controlId={`validationFormha105`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha105-label`}
            >
              Suburb
            </Form.Label>
            <Form.Control
              type="text"
              name="suburb"
              value={fieldValues["suburb"]}
              placeholder="Add suburb"
              readOnly={readOnlyValues["suburb"]}
              onChange={handleChange}
              isInvalid={fieldErrors["suburb"]}
              className={fieldErrors["suburb"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["suburb"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            as={Col}
            xs="12"
            sm="4"
            md="4"
            className={formStyles["form-group"]}
            controlId={`validationFormha106`}
          >
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha106-label`}
            >
              Postal code
            </Form.Label>
            <Form.Control
              type="text"
              name="postalCode"
              value={fieldValues["postalCode"]}
              placeholder="#"
              readOnly={readOnlyValues["postalCode"]}
              maxLength="4"
              onChange={handleChange}
              isInvalid={fieldErrors["postalCode"]}
              className={fieldErrors["postalCode"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["postalCode"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormha107`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormha107-label`}
            >
              Town / City
            </Form.Label>
            <Form.Control
              type="text"
              name="town"
              value={fieldValues["town"]}
              placeholder="Add town / city"
              readOnly={readOnlyValues["town"]}
              onChange={handleChange}
              isInvalid={fieldErrors["town"]}
              className={fieldErrors["town"] ? formStyles["invalid"] : ""}
              onBlur={handleBlur}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["town"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormha108`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormha108-label`}
            >
              Province
            </Form.Label>
            <DropDown
              formName={formName}
              name="province"
              label="Province"
              data={stateTypesOptions}
              required={true}
              handleSelect={onDropdownChange}
              selectedId={fieldValues["province"]}
              customId={`validationFormha108`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["province"]}
            />
            {fieldErrors["province"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["province"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form.Row>

        {currentJourneyType != journeyType.addLine && (
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormha1082`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormha1082-label`}
            >
              Do you own or rent this property?
            </Form.Label>
            <DropDown
              formName={formName}
              name="residence"
              label="Residence"
              data={residenceTypes}
              required={true}
              handleSelect={onDropdownChange}
              selectedId={fieldValues["residence"]}
              customId={`validationFormha1082`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["residence"]}
            />
            {fieldErrors["residence"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["residence"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        )}

        {currentJourneyType != journeyType.addLine && (
          <Form.Row className={formStyles["form-row"]}>
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha1080-label`}
            >
              How long did you live at this address?
            </Form.Label>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormha10801`}
            >
              <Form.Control
                type="text"
                name="currentAddressYears"
                value={fieldValues["currentAddressYears"]}
                placeholder="Years"
                required
                maxLength="2"
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                isInvalid={fieldErrors["currentAddressPeriod"]}
                className={
                  fieldErrors["currentAddressPeriod"]
                    ? formStyles["invalid"]
                    : ""
                }
              />
            </Form.Group>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormha10802`}
            >
              <Form.Control
                type="text"
                name="currentAddressMonths"
                value={fieldValues["currentAddressMonths"]}
                placeholder="Months"
                required
                maxLength="2"
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                isInvalid={fieldErrors["currentAddressPeriod"]}
                className={
                  fieldErrors["currentAddressPeriod"]
                    ? formStyles["invalid"]
                    : ""
                }
              />
            </Form.Group>
            {fieldErrors["currentAddressPeriod"] && (
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                className={`${formStyles["form-group"]} p-0`}
                controlId={`validationFormha108021`}
              >
                <Form.Control.Feedback
                  type="invalid"
                  className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
                >
                  {fieldErrorsMessage["currentAddressPeriod"]}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Form.Row>
        )}

        {currentJourneyType != journeyType.addLine && (
          <Form.Row className={formStyles["form-row"]}>
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormha1081-label`}
            >
              How long did you live at your previous address?
            </Form.Label>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormha10811`}
            >
              <Form.Control
                type="text"
                name="previousAddressYears"
                value={fieldValues["previousAddressYears"]}
                placeholder="Years"
                required
                maxLength="2"
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                isInvalid={fieldErrors["previousAddressPeriod"]}
                className={
                  fieldErrors["previousAddressPeriod"]
                    ? formStyles["invalid"]
                    : ""
                }
              />              
            </Form.Group>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormha10812`}
            >
              <Form.Control
                type="text"
                name="previousAddressMonths"
                value={fieldValues["previousAddressMonths"]}
                placeholder="Months"
                required
                maxLength="2"
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                isInvalid={fieldErrors["previousAddressPeriod"]}
                className={
                  fieldErrors["previousAddressPeriod"]
                    ? formStyles["invalid"]
                    : ""
                }
              />
            </Form.Group>
            {fieldErrors["previousAddressPeriod"] && (
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                className={formStyles["form-group"]}
                controlId={`validationFormha108021`}
              >
                <Form.Control.Feedback
                  type="invalid"
                  className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
                >
                  {fieldErrorsMessage["previousAddressPeriod"]}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Form.Row>
        )}

        
      </Form.Row>
    </CustomContainer>
  );
};

HomeAddressForm.propTypes = {
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  readOnlyValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
  stateTypesOptions: PropTypes.array,
  onBlurHandler: PropTypes.func,
};

HomeAddressForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  stateTypesOptions: [],
};

export default HomeAddressForm;
